/* eslint-disable camelcase */

module.exports = {
	methods: {
		tags() {
			const self = this;

			return {
				async list({ type = null, show_image = false, search = null, order_by = 'date', offset = 0, limit = self.limit, only_subscribed = null, only_not_subscribed = null, flushCache = false }) {
					try {
						const headers = { Authorization: false };
						if (flushCache) headers['Cache-Control'] = 'no-cache';

						const response = await self.$http.get(
							'tags', {
								params: {
									type,
									show_image: show_image ? 1 : 0,
									search,
									only_subscribed: only_subscribed ? 1 : 0,
									only_not_subscribed: only_not_subscribed ? 1 : 0,
									offset,
									order_by,
									limit,
								},
								headers,
							},
						);

						return {
							ok: true,
							data: response.data.tags,
							error: null,
						};
					} catch (error) {
						return {
							ok: false,
							data: [],
							error: null,
						};
					}
				},
				async popular({ type = '', offset = 0, limit = self.limit, flushCache = false }) {
					try {
						const headers = { Authorization: false };
						if (flushCache) headers['Cache-Control'] = 'no-cache';

						const response = await self.$http.get(
							'tags', {
								params: {
									show_image: 1,
									order_by: 'popularity',
									limit,
									offset,
									type,
								},
								headers,
							},
						);

						return {
							ok: true,
							data: response.data.tags,
							error: null,
						};
					} catch (error) {
						return {
							ok: false,
							data: [],
							error: null,
						};
					}
				},
				async get({ id, find_deals = 0, offset = 0, limit = self.limit }) {
					try {
						const response = await self.$http.get(
							`tags/${id}`, {
								params: {
									find_deals: find_deals ? 1 : 0,
									offset,
									limit,
								},
								headers: {
									Authorization: false,
								},
							},
						);

						const { tag } = response.data;
						let deals = null;

						if (find_deals === true) {
							deals = {
								total: response.data.deals.total,
								results: self.helpers().formatDeals(response.data.deals.results),
							};
						}

						return {
							ok: true,
							data: tag,
							deals,
							error: null,
						};
					} catch (error) {
						return {
							ok: false,
							data: [],
							error: null,
						};
					}
				},
				async bell(tagId, type) {
					try {
						await self.$http.put(
							`tags/${tagId}/bell/${type}`, null, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
				async unbell(tagId) {
					try {
						await self.$http.delete(
							`tags/${tagId}/bell`, null, {
								headers: {
									Authorization: true,
								},
							},
						);

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
			};
		},
	},
};
